import { motion } from "framer-motion";
import { useT } from "@/i18n_extra3";

export const Team = () => {
  const t = useT();
  return (
    <section className="py-28 sm:py-32 bg-[#F3F1EC] border-y border-black/5" data-testid="team-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#B8860B]" />
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#B8860B]">{t.team.label}</span>
          </div>
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#111111]">{t.team.title}</h2>
          <p className="mt-5 text-black/60 text-base sm:text-lg leading-relaxed">{t.team.sub}</p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 gap-8 max-w-4xl">
          {["/assets/team-1.png", "/assets/team-2.png"].map((src, i) => (
            <motion.figure
              key={src}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="group"
              data-testid={`team-card-${i + 1}`}
            >
              <div className="relative overflow-hidden rounded-2xl border border-black/10 shadow-lg">
                <img src={src} alt={t.team.roles[i]} className="w-full h-[380px] object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-5">
                  <span className="text-[#D4AF37] font-display font-semibold text-lg">{t.team.roles[i]}</span>
                  <span className="block text-white/70 text-xs tracking-widest uppercase mt-0.5">ClearRoute Auto Glass</span>
                </div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
